import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, InputGroup } from 'reactstrap';
import './ReportGenerator.css';
import PortActivationBody from './PortActivationBody';
import Spinner from './Spinner/Spinner';

const PortActivationModal = ({
  isOpen,
  onCancel,
  onConfirm,
  companies,
  locations,
  selectedCompany,
  selectedDates,
  selectAlarmProtocol,
  alarmProtocolValue,
  selectedReport,
  includeSummary,
  alarmProtocol,
  summaryStatus,
  downloadType,
  locationId,
  loading,
  user,
  companyGroups,
  reportSymbol,
  lineTypes,
  reportName,
  setUptimeOpt,
  setIntegrationValue,
}) => {
  const [disabled, setDisabled] = useState(true);
  const disabledButton = value => {
    setDisabled(value);
  };
  const onPressCancel = () => {
    setDisabled(true);
    onCancel();
  };
  const selectedLineTypes = e => {
    lineTypes(e);
  };
  return (
    <Modal isOpen={isOpen} className="create-box-modal">
      {loading && <Spinner />}
      <ModalHeader>
        {reportName}
      </ModalHeader>
      <ModalBody>
        <div className="container available">
          <PortActivationBody
            selectedReport={selectedReport}
            includeSummary={includeSummary}
            alarmProtocol={alarmProtocol}
            locations={locations}
            companies={companies}
            selectedCompany={selectedCompany}
            selectedDates={selectedDates}
            selectAlarmProtocol={selectAlarmProtocol}
            alarmProtocolValue={alarmProtocolValue}
            locationId={locationId}
            disabledButton={disabledButton}
            summaryStatus={summaryStatus}
            downloadType={downloadType}
            user={user}
            companyGroups={companyGroups}
            reportSymbol={reportSymbol}
            selectedLineTypes={selectedLineTypes}
            setUptimeOpt={setUptimeOpt}
            setIntegrationValue={setIntegrationValue}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button outline onClick={onPressCancel}>
          Cancel
        </Button>
        <Button disabled={disabled} color="primary" onClick={onConfirm}>
          Generate Report
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PortActivationModal;
